export default __webpack_public_path__ + "static/media/mobile.5e3b0f5f.jfif";